import {
  SUPERVISOR_REVISION_PANEL_GET_PERIODS_LIST_INIT,
  SUPERVISOR_REVISION_PANEL_GET_PERIODS_LIST_SUCCESS,
  SUPERVISOR_REVISION_PANEL_GET_PERIODS_LIST_FAILURE,
  SUPERVISOR_REVISION_PANEL_GET_REVISIONS_LIST_INIT,
  SUPERVISOR_REVISION_PANEL_GET_REVISIONS_LIST_SUCCESS,
  SUPERVISOR_REVISION_PANEL_GET_REVISIONS_LIST_FAILURE,
  SUPERVISOR_REVISION_PANEL_GET_ALL_SUPERVISORS_REVISIONS_INIT,
  SUPERVISOR_REVISION_PANEL_GET_ALL_SUPERVISORS_REVISIONS_SUCCESS,
  SUPERVISOR_REVISION_PANEL_GET_ALL_SUPERVISORS_REVISIONS_FAILURE,  
  SUPERVISOR_REVISION_PANEL_GET_SUPERVISOR_MODEL_REVISION_HISTORY_INIT,
  SUPERVISOR_REVISION_PANEL_GET_SUPERVISOR_MODEL_REVISION_HISTORY_SUCCESS,
  SUPERVISOR_REVISION_PANEL_GET_SUPERVISOR_MODEL_REVISION_HISTORY_FAILURE,
  SUPERVISOR_REVISION_PANEL_GET_MODELS_LIST_INIT,
  SUPERVISOR_REVISION_PANEL_GET_MODELS_LIST_SUCCESS,
  SUPERVISOR_REVISION_PANEL_GET_MODELS_LIST_FAILURE,
  SUPERVISOR_REVISION_PANEL_SET_REVISION_STATUS_INIT,
  SUPERVISOR_REVISION_PANEL_SET_REVISION_STATUS_SUCCESS,
  SUPERVISOR_REVISION_PANEL_SET_REVISION_STATUS_FAILURE,
  SUPERVISOR_REVISION_PANEL_DOWNLOAD_REVISION_INIT,
  SUPERVISOR_REVISION_PANEL_DOWNLOAD_REVISION_SUCCESS,
  SUPERVISOR_REVISION_PANEL_DOWNLOAD_REVISION_FAILURE,
  SUPERVISOR_REVISION_PANEL_SET_PERIOD_ID,
  SUPERVISOR_REVISION_PANEL_SOFT_RESET,
  SUPERVISOR_REVISION_PANEL_RESET,
} from './types';
import Constants from '../../../definitions/constants';
import ActionsTooling from '../../../tooling/actionsTooling';
import FilesTooling from '../../../tooling/filesTooling';
import { intl } from '../../../locales/localesConfig';

export function downloadRevision(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(SUPERVISOR_REVISION_PANEL_DOWNLOAD_REVISION_INIT));
    try {
      const resp = await FilesTooling.downloadFileClientSide(
        "/api/supervisor/downloadrevision",
        params.revision_file_name,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(SUPERVISOR_REVISION_PANEL_DOWNLOAD_REVISION_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(SUPERVISOR_REVISION_PANEL_DOWNLOAD_REVISION_FAILURE, error));
    }  
  };
}

export function setRevisionStatus(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(SUPERVISOR_REVISION_PANEL_SET_REVISION_STATUS_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/supervisor/setrevisionstatus",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(SUPERVISOR_REVISION_PANEL_SET_REVISION_STATUS_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(SUPERVISOR_REVISION_PANEL_SET_REVISION_STATUS_FAILURE, error));
    }  
  };
}

export function getRevisionsList(params, paging = false) {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: SUPERVISOR_REVISION_PANEL_GET_REVISIONS_LIST_INIT,
      params: params,
      paging: paging
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/supervisor/getallrevisions",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(SUPERVISOR_REVISION_PANEL_GET_REVISIONS_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(SUPERVISOR_REVISION_PANEL_GET_REVISIONS_LIST_FAILURE, error));
    }  
  };
}

export function getAllRevisionsList(params, paging = false) {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: SUPERVISOR_REVISION_PANEL_GET_ALL_SUPERVISORS_REVISIONS_INIT,
      params: params,
      paging: paging
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/supervisor/getallrevisions",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(SUPERVISOR_REVISION_PANEL_GET_ALL_SUPERVISORS_REVISIONS_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(SUPERVISOR_REVISION_PANEL_GET_ALL_SUPERVISORS_REVISIONS_FAILURE, error));
    }  
  };
}

export function getSupervisorModelRevisionHistory(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(SUPERVISOR_REVISION_PANEL_GET_SUPERVISOR_MODEL_REVISION_HISTORY_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/supervisor/getsupervisormodelrevisionhistory",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(SUPERVISOR_REVISION_PANEL_GET_SUPERVISOR_MODEL_REVISION_HISTORY_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(SUPERVISOR_REVISION_PANEL_GET_SUPERVISOR_MODEL_REVISION_HISTORY_FAILURE, error));
    }  
  };
}

export function getModelsList() {
  let params = {
    mini_list_version: true, 
    order_fields: ["name"],
    order_directions: [Constants.crudGenerator.orderTypes.ASC],
    fields_are: ["active", "model", "exclude_from_ux_active_models_lists"],
    searches_are: [true, true, "false"],
    only_current_user_models: true,
    per_page: Constants.interface.fullListPageSize
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: SUPERVISOR_REVISION_PANEL_GET_MODELS_LIST_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/polynomial/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(SUPERVISOR_REVISION_PANEL_GET_MODELS_LIST_SUCCESS , resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(SUPERVISOR_REVISION_PANEL_GET_MODELS_LIST_FAILURE, error));
    }  
  };
}

export function getPeriodsList() {
  let params = {
    mini_list_version: true, 
    order_fields: ["end_date", "created_at"],
    order_directions: [Constants.crudGenerator.orderTypes.DESC, Constants.crudGenerator.orderTypes.DESC],
    fields_are: ["active"],
    searches_are: [true],
    per_page: Constants.interface.fullListPageSize
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: SUPERVISOR_REVISION_PANEL_GET_PERIODS_LIST_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/period/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(SUPERVISOR_REVISION_PANEL_GET_PERIODS_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(SUPERVISOR_REVISION_PANEL_GET_PERIODS_LIST_FAILURE, error));
    }  
  };
}

export function setPeriodId(id) {
  return {
    type: SUPERVISOR_REVISION_PANEL_SET_PERIOD_ID,
    id: id
  };
}

export function softReset() {
  return {
    type: SUPERVISOR_REVISION_PANEL_SOFT_RESET
  };
}

export function reset() {
  return {
    type: SUPERVISOR_REVISION_PANEL_RESET
  };
}




// WEBPACK FOOTER //
// ./source/client/actions/supervisorRevisionPanel/index.js